<template>
  <div class="feedback-container">
    <button @click="toggleFeedback" class="feedback-button">
      Feedback
    </button>
    <div class="feedback-overlay" v-if="isVisible">
      <div class="feedback-form">
        <h2 class="feedback-title">Feedback</h2>
        <div class="star-rating">
          <span v-for="star in 5" :key="star" @click="setRating(star)" class="star">
            {{ star <= rating ? '★' : '☆' }} </span>
        </div>
        <textarea v-model="comment"
          placeholder="Please share your thoughts with us! Your feedback is anonymous and helps us improve."
          class="feedback-textarea"></textarea>
        <div class="button-group">
          <button @click="cancelFeedback" class="feedback-cancel-button" :disabled="isSubmitting">
            Cancel
          </button>
          <button @click="submitFeedback" class="feedback-submit-button" :disabled="isSubmitting">
            {{ isSubmitting ? 'Sending...' : 'Send' }}
          </button>
        </div>
        <p v-if="submitError" class="error-message">{{ submitError }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';

export default {
  name: 'FeedbackButton',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      rating: 0,
      comment: '',
      isSubmitting: false,
      submitError: null
    }
  },
  methods: {
    toggleFeedback() {
      this.$emit('toggle');
    },
    setRating(value) {
      this.rating = value;
    },
    async submitFeedback() {
      if (this.rating === 0) {
        alert("Bitte wählen Sie eine Bewertung aus, bevor Sie absenden.");
        return;
      }

      this.isSubmitting = true;
      this.submitError = null;

      try {

        console.log('About to call post feedback:', this.rating, this.comment);
        const response = await apiService.submitFeedback({
          rating: this.rating,
          comment: this.comment
        });

        console.log('Feedback submitted successfully:', response);

        this.$emit('feedback-submitted', response);
        this.$emit('toggle');
        this.resetForm();
      } catch (error) {
        console.error('Error submitting feedback:', error);
        this.submitError = "Failed to submit feedback. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
    cancelFeedback() {
      this.$emit('toggle');
      this.resetForm();
    },
    resetForm() {
      this.rating = 0;
      this.comment = '';
      this.submitError = null;
    }
  }
}
</script>

<style scoped>
.feedback-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.feedback-button {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.feedback-button:hover {
  background-color: #2E7D32;
}

.feedback-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.feedback-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  font-family: Arial, sans-serif;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.feedback-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.star-rating {
  font-size: 24px;
  color: gold;
  margin-bottom: 15px;
}

.star {
  cursor: pointer;
}

.feedback-textarea {
  width: 100%;
  height: 100px;
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  box-sizing: border-box;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

.feedback-submit-button,
.feedback-cancel-button {
  padding: 8px 15px;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.feedback-submit-button {
  background-color: #42b983;
}

.feedback-submit-button:hover:not(:disabled) {
  background-color: #2E7D32;
}

.feedback-cancel-button {
  background-color: #dc3545;
}

.feedback-cancel-button:hover:not(:disabled) {
  background-color: #c82333;
}

.feedback-submit-button:disabled,
.feedback-cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  margin-top: 10px;
}
</style>